import React from "react";
import { presentationStatut } from "./effacementDonnees";

const PuceStatut = ({ statut }) => {
  const { ton, icone, prefixe } = presentationStatut(statut.id);
  return (
    <span className={`effacement__puce effacement__ton--${ton}`}>
      <i className={`${prefixe} fa-${icone}`} aria-hidden="true" />
      {statut.libelle}
    </span>
  );
};

export default PuceStatut;
